// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2888":"c9ff959d603ff861","6110":"5021329d1cc7035a","6579":"5021329d1cc7035a","8816":"2ecc03122e42efdd","8977":"5021329d1cc7035a"}[chunkId] + ".css";
};